export const es = {
  // Navigation
  nav: {
    dashboard: 'Panel',
    profile: 'Perfil',
    signOut: 'Cerrar Sesión',
    settings: 'Configuración',
  },

  // Dashboard
  dashboard: {
    welcome: 'Bienvenido de nuevo',
    welcomeSubtext: 'Administra tus eventos y conecta con amigos',
    calendar: 'Calendario',
    createEvent: 'Crear Evento',
    yourEvents: 'Tus Eventos',
    manageEvents: 'Administra y rastrea todos tus eventos',
    searchEvents: 'Buscar eventos...',
    filter: {
      all: 'Todos los Eventos',
      hosting: 'Organizando',
      attending: 'Asistiendo',
    },
    stats: {
      totalEvents: 'Total de Eventos',
      hosting: 'Organizando',
      attending: 'Asistiendo',
    },
    noEvents: 'Sin eventos aún',
    noEventsFound: 'No se encontraron eventos',
    noEventsDescription: '¡Crea tu primer evento para comenzar y reunir a las personas!',
    noEventsFoundDescription: 'Intenta ajustar tu búsqueda o criterios de filtro.',
    loading: 'Cargando tu panel...',
    syncingProfile: 'Sincronizando tu información de perfil...',
  },

  // Event Tile
  eventTile: {
    host: 'Anfitrión',
    upcoming: 'Próximo',
    past: 'Pasado',
    attending: 'asistiendo',
    manageEvent: 'Administrar Evento',
    daysOfWeek: {
      Sun: 'Dom',
      Mon: 'Lun',
      Tue: 'Mar',
      Wed: 'Mié',
      Thu: 'Jue',
      Fri: 'Vie',
      Sat: 'Sáb',
    },
    monthsShort: {
      Jan: 'Ene',
      Feb: 'Feb',
      Mar: 'Mar',
      Apr: 'Abr',
      May: 'May',
      Jun: 'Jun',
      Jul: 'Jul',
      Aug: 'Ago',
      Sep: 'Sep',
      Oct: 'Oct',
      Nov: 'Nov',
      Dec: 'Dic',
    },
  },

  // Calendar
  calendar: {
    upcomingEvents: 'Próximos Eventos',
    hosting: 'Organizando',
    attending: 'Asistiendo',
    event: 'evento',
    events: 'eventos',
    more: 'más',
    daysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  },

  // Event Dashboard
  event: {
    tasks: 'Tareas',
    expenses: 'Gastos',
    attendees: 'Asistentes al Evento',
    seeWhosComing: 'Ve quién asistirá a tu evento',
    shareEvent: 'Compartir Evento',
    locationNotSpecified: 'Ubicación no especificada',
    loadingEvent: 'Cargando evento...',
    loadingProfile: 'Cargando tu perfil...',
    back: 'Atrás',
    loadingAttendees: 'Cargando asistentes...',
    personGoing: 'Persona Asistiendo',
    peopleGoing: 'Personas Asistiendo',
    host: 'Anfitrión',
    eventHost: 'Anfitrión del Evento',
    attendee: 'Asistente',
    noAttendeesYet: 'Sin asistentes aún',
    shareEventInvite: 'Comparte el enlace de tu evento para invitar personas y verlas aparecer aquí.',
    pageOf: 'de',
  },

  // Event Data
  eventData: {
    host: 'Anfitrión',
    joinEvent: 'Unirse al Evento',
    leaveEvent: 'Abandonar Evento',
    editEvent: 'Editar Evento',
    deleteEvent: 'Eliminar Evento',
    shareLink: 'Compartir Enlace',
    linkCopied: '¡Enlace del evento copiado al portapapeles!',
    confirmDelete: '¿Estás seguro de que quieres eliminar este evento?',
    deleteWarning: 'Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    youreTheHost: 'Eres el Anfitrión',
    personAttending: 'persona asistiendo',
    peopleAttending: 'personas asistiendo',
    aboutThisEvent: 'Acerca de este evento',
    location: 'Ubicación',
    tags: 'Etiquetas',
    eventParticipation: 'Participación en el Evento',
    shareEvent: 'Compartir Evento',
    hostActions: 'Acciones del Anfitrión',
    upcomingEvent: 'Evento Próximo',
    pastEvent: 'Evento Pasado',
    eventStatistics: 'Estadísticas del Evento',
    totalAttendees: 'Total de Asistentes',
    eventStatus: 'Estado del Evento',
    upcoming: 'Próximo',
    completed: 'Completado',
    timeUntilEvent: 'Tiempo hasta el Evento',
  },

  // Share Event Modal
  shareModal: {
    shareEvent: 'Compartir Evento',
    shareThisEvent: 'Compartir este evento',
    copyLink: 'Copiar Enlace',
    linkCopied: '¡Enlace copiado!',
    copyLinkTitle: 'Copiar enlace',
    joinMyEvent: 'Únete a mi evento',
    checkOutThisEvent: 'Echa un vistazo a este evento',
    email: 'Email',
    whatsapp: 'WhatsApp',
    twitter: 'Twitter',
    facebook: 'Facebook',
  },

  // Edit Event Modal
  editModal: {
    editEvent: 'Editar Evento',
    updateEventDetails: 'Actualiza los detalles de tu evento',
    eventName: 'Nombre del Evento',
    eventNamePlaceholder: 'ej., Fiesta de Cumpleaños de Anna',
    dateTime: 'Fecha y Hora',
    selectDateTime: 'Selecciona fecha y hora',
    location: 'Ubicación',
    locationPlaceholder: 'ej., Calle Arcoíris 123, Ciudad',
    description: 'Descripción',
    descriptionPlaceholder: 'Dile a las personas qué esperar en tu evento...',
    eventImage: 'Imagen del Evento',
    eventPreview: 'Vista previa del evento',
    clickToUpload: 'Haz clic para subir imagen del evento',
    updateEvent: 'Actualizar Evento',
    updatingEvent: 'Actualizando Evento...',
    required: '*',
  },

  // Delete Event Modal
  deleteModal: {
    deleteEvent: 'Eliminar Evento',
    cannotBeUndone: 'Esta acción no se puede deshacer',
    deleteEventTitle: '¿Eliminar "{title}"?',
    confirmDelete: '¿Estás seguro de que quieres eliminar este evento?',
    dataWillBeRemoved: 'Todos los datos del evento, tareas y gastos serán eliminados permanentemente.',
    friendsWillBeSad: 'Tus amigos estarán tristes 😔',
    cancel: 'Cancelar',
    deleting: 'Eliminando...',
    errorDeleting: 'Error al eliminar el evento.',
  },

  // Create Event Form
  createEvent: {
    title: 'Crear Nuevo Evento',
    subtitle: 'Reúne a las personas',
    hostEvent: 'Organizar Evento',
    eventTitle: 'Título del Evento',
    eventTitlePlaceholder: 'Ingresa el título del evento',
    eventName: 'Nombre del Evento',
    eventNamePlaceholder: 'ej., Fiesta de Cumpleaños de Anna',
    description: 'Descripción',
    descriptionPlaceholder: 'Describe tu evento',
    descriptionPlaceholderLong: 'Dile a las personas qué esperar en tu evento...',
    location: 'Ubicación',
    locationPlaceholder: '¿Dónde es tu evento?',
    locationPlaceholderLong: 'ej., Calle Arcoíris 123, Ciudad',
    date: 'Fecha',
    time: 'Hora',
    dateTime: 'Fecha y Hora',
    selectDateTime: 'Selecciona fecha y hora',
    eventImage: 'Imagen del Evento',
    uploadImage: 'Subir Imagen',
    clickToUpload: 'Haz clic para subir imagen del evento',
    browseFiles: 'explorar',
    dragAndDrop: 'Arrastra y suelta una imagen aquí, o',
    imageRequirements: 'JPG, PNG o GIF (Máx 5MB)',
    cancel: 'Cancelar',
    create: 'Crear Evento',
    creating: 'Creando...',
    creatingEvent: 'Creando Evento...',
    eventCreatedSuccess: '¡Evento creado exitosamente!',
    requiredField: '*',
    userIdentificationError: 'No se puede identificar al usuario. Por favor, actualiza la página e intenta de nuevo.',
  },

  // Expenses
  expenses: {
    title: 'Gastos del Evento',
    addExpense: 'Agregar Gasto',
    description: 'Descripción',
    amount: 'Cantidad',
    paidBy: 'Pagado por',
    actions: 'Acciones',
    noExpenses: 'Sin gastos aún',
    noExpensesDescription: 'Comienza a rastrear los gastos de este evento',
    paymentBalance: 'Balance de Pagos',
    totalExpenses: 'Gastos Totales',
    perPerson: 'Por Persona',
    youOwe: 'Debes',
    owesYou: 'te debe',
    settledUp: '¡Saldado!',
    paid: 'Pagado',
    balance: 'Balance',
    suggestedPayments: 'Pagos Sugeridos',
    pays: 'paga',
    descriptionPlaceholder: '¿Para qué fue este gasto?',
    amountPlaceholder: 'Cantidad',
    selectPayer: 'Selecciona quién pagó',
    trackAndManage: 'Rastrea y administra los costos del evento',
    averageExpense: 'Gasto Promedio',
    totalItems: 'Total de Artículos',
    expenseHistory: 'Historial de Gastos',
    spendingBreakdown: 'Desglose de Gastos',
    settlementDescription: 'Quién debe dinero y a quién se le debe',
    splitEqually: 'Dividido equitativamente entre',
    attendee: 'asistente',
    attendees: 'asistentes',
    everyonePaid: 'Todos han pagado su parte justa',
    to: 'a',
    settleBalancesInstruction: 'Para saldar todos los balances, realiza estos pagos:',
  },

  // Settings
  settings: {
    title: 'Configuración',
    currency: 'Moneda',
    language: 'Idioma',
    theme: 'Tema',
    lightTheme: 'Claro',
    darkTheme: 'Oscuro',
    saveChanges: 'Guardar Cambios',
    cancel: 'Cancelar',
    currencies: {
      usd: 'Dólar Estadounidense',
      eur: 'Euro',
      gbp: 'Libra Esterlina',
    },
    languages: {
      english: 'English',
      spanish: 'Español',
      french: 'Français',
    },
  },

  // Profile
  profile: {
    title: 'Configuración del Perfil',
    subtitle: 'Administra la información y preferencias de tu cuenta',
    personalInfo: 'Información Personal',
    security: 'Seguridad',
    fullName: 'Nombre Completo',
    phoneNumber: 'Número de Teléfono',
    emailAddress: 'Correo Electrónico',
    profilePicture: 'Foto de Perfil',
    uploadPhoto: 'Subir Foto',
    uploading: 'Subiendo...',
    photoInfo: 'JPG, PNG o GIF. Tamaño máximo de 5MB.',
    currentPassword: 'Contraseña Actual',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Nueva Contraseña',
    passwordStrength: 'Fortaleza de la Contraseña',
    saveChanges: 'Guardar Cambios',
    saving: 'Guardando...',
    profileUpdated: '¡Perfil actualizado exitosamente!',
    namePlaceholder: 'Ingresa tu nombre completo',
    phonePlaceholder: 'Ingresa tu número de teléfono',
    emailPlaceholder: 'Ingresa tu correo electrónico',
    currentPasswordPlaceholder: 'Ingresa la contraseña actual para cambiar',
    newPasswordPlaceholder: 'Ingresa la nueva contraseña',
    confirmPasswordPlaceholder: 'Confirma la nueva contraseña',
    backToDashboard: 'Volver al Panel',
    loadingProfile: 'Cargando perfil...',
    userDataNotLoaded: 'Datos de usuario no cargados. Por favor actualiza la página.',
    passwordsDoNotMatch: 'Las nuevas contraseñas no coinciden',
    passwordTooWeak: 'La contraseña es muy débil. Por favor usa una contraseña más fuerte.',
    noChangesToSave: 'No hay cambios para guardar.',
    emailAlreadyInUse: 'Este correo ya está en uso por otra cuenta.',
    updateError: 'Error al actualizar el perfil. Por favor intenta de nuevo.',
    generalError: 'Ocurrió un error al actualizar tu perfil.',
    uploadImageError: 'Error al subir la imagen',
    updateProfilePicError: 'Error al actualizar la foto de perfil',
    retryUpload: 'Error al subir la imagen. Por favor, intenta de nuevo.',
  },

  // Tasks/Todos
  tasks: {
    title: 'Tareas del Evento',
    subtitle: 'Organiza y rastrea las tareas de tu evento',
    addNewTask: 'Agregar nueva tarea',
    pendingCompleted: '{pending} pendientes, {completed} completadas',
    loadingTasks: 'Cargando tareas...',
    enterTaskDescription: 'Ingresa la descripción de la tarea...',
    pendingTasks: 'Tareas Pendientes',
    completedTasks: 'Tareas Completadas',
    noPendingTasks: 'Sin tareas pendientes',
    noCompletedTasks: 'Sin tareas completadas aún',
    progressOverview: 'Resumen de Progreso',
    tasksCompleted: '{completed} de {total} tareas completadas',
    remaining: '{remaining} restantes',
    completed: 'Completada',
    markAsIncomplete: 'Marcar como incompleta',
  },

  // Common
  common: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    submit: 'Enviar',
    search: 'Buscar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    refresh: 'Actualizar',
    add: 'Agregar',
    remove: 'Quitar',
    yes: 'Sí',
    no: 'No',
    altText: {
      profile: 'Perfil',
      eventPreview: 'Vista previa del evento',
    },
  },
};